import apiInstance from "../api";
import endPoints from "../endpoints";

export const addMasterInvestment = (payload) => {
  return apiInstance().post(endPoints.trade.addMasterInvestment, payload);
};

export const getMasterInvestmentBySearchCriteria = (payload) => {
  return apiInstance().post(
    endPoints.trade.getMasterInvestmentBySearchCriteria,
    payload
  );
};

export const getCompetingFunds = (payload) => {
  return apiInstance().get(`${endPoints.trade.getCompetingFunds}/${payload}`);
};

export const getApplicableInvestments = () => {
  return apiInstance().get(`${endPoints.trade.getApplicableInvestments}`);
};

export const getInvestment = (id) => {
  return apiInstance().get(`${endPoints.trade.getInvestment}/${id}`);
};

export const deleteMasterInvestmentById = (investmentId) => {
  return apiInstance().delete(
    `${endPoints.trade.deleteMasterInvestmentById}/${investmentId}`
  );
};

export const getInvestmentType = () => {
  return apiInstance().get(`${endPoints.trade.getInvestmentType}`);
};

export const getInvestmentCategory = () => {
  return apiInstance().get(`${endPoints.trade.getInvestmentCategory}`);
};

export const addInvestmentType = (payload) => {
  return apiInstance().post(endPoints.trade.addInvestmentType, payload);
};

export const addInvestmentCategory = (payload) => {
  return apiInstance().post(endPoints.trade.addInvestmentCategory, payload);
};
